// components/dashboard/SidebarTabs.tsx
import React from "react";
import {
  FileDown,
  LineChart,
  Table,
  PieChart,
  Flame,
  User,
} from "lucide-react";

export type TabKey =
  | "chart"
  | "table"
  | "pie"
  | "bar"
  | "explorer"
  | "export"
  | "distribution"
  | "topBurners";

interface SidebarTabsProps {
  activeTab: TabKey;
  setActiveTab: (tab: TabKey) => void;
}

const tabOptions = [
  { key: "chart", label: "Chart", icon: <LineChart size={18} /> },
  { key: "table", label: "Table", icon: <Table size={18} /> },
  { key: "distribution", label: "Distribution", icon: <PieChart size={18} /> },
  { key: "bar", label: "Top Burners", icon: <Flame size={18} /> },
  { key: "explorer", label: "Explorer", icon: <User size={18} /> },
  { key: "export", label: "Export", icon: <FileDown size={18} /> },
];

const SidebarTabs: React.FC<SidebarTabsProps> = ({
  activeTab,
  setActiveTab,
}) => (
  <aside className="w-full md:w-1/8 flex flex-col items-centre gap-2 md:mt-70">
    {tabOptions.map(({ key, label, icon }) => (
      <button
        key={key}
        onClick={() => setActiveTab(key as TabKey)}
        aria-current={activeTab === key ? "page" : undefined}
        className={`w-full min-h-[42px] flex items-center justify-end gap-2 px-4 py-2 rounded font-semibold transition ${
          activeTab === key
            ? "bg-blue-900 text-white shadow"
            : "bg-gray-100 text-[#333] hover:bg-gray-200"
        }`}
      >
        {label} {icon}
      </button>
    ))}
  </aside>
);

export default SidebarTabs;
